import {filter} from 'rxjs/operators';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import { UntypedFormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {Store} from '@ngxs/store';
import {BlogState} from '../state/blog.state';
import {NewsletterSubscription} from '../models';
import {BlogService} from '../blog.service';
import {SendSubscription, UpdateSubscription} from '../state/blog.actions';
import {AuthState} from '../../../auth/states/auth/auth.state';
import {HttpSingleFormComponent} from '../../../rt-forms/http-single-form-component';
import {FADE_IN} from '../../../shared/animations';
import {MessagesState} from '../../../messages/messages.state';
import {ClearMessages} from '../../../messages/messages.actions';
import { InputBlockComponent } from '../../../rt-forms/input-block/input-block.component';
import { AsyncPipe } from '@angular/common';


@Component({
    selector: 'app-blog-newsletter',
    templateUrl: './blog-newsletter.component.html',
    styleUrls: ['./blog-newsletter.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [FADE_IN],
    imports: [FormsModule, ReactiveFormsModule, InputBlockComponent, AsyncPipe]
})
export class BlogNewsletterComponent extends HttpSingleFormComponent implements OnInit, OnDestroy {
  public readonly newsletterSubscription$ = this.store.select(BlogState.subscription);
  public readonly isAuthenticated$ = this.store.select(AuthState.isAuthenticated);
  public readonly backendErrors$ = this.store.select(MessagesState.getBackendError);

  protected API_ENDPOINT = '/api/blog/subscription/';

  formLabels = {
    email: 'Email address',
  };

  formFields = {
    email: [Validators.required, Validators.email, Validators.maxLength(254)],
  };

  validationMessages = {
    email: {
      required: '%label is required',
      email: '%label is not valid',
      maxlength: '%label should not be more than 200 characters'
    },
  };

  currentSubscription: NewsletterSubscription = null;

  error = null;

  constructor(
    protected fb: UntypedFormBuilder,
    protected http: HttpClient,
    protected cd: ChangeDetectorRef,
    public blogService: BlogService,
    private store: Store,
  ) {
    super(fb, cd, http);
  }

  ngOnInit() {
    super.ngOnInit();
    this.store.dispatch(new ClearMessages());

    this.subscription.add(
      this.newsletterSubscription$.pipe(filter(x => !!x)).subscribe(sub => {
        this.currentSubscription = sub;
      })
    );

    this.subscription.add(
      this.backendErrors$.subscribe(httpError => {
        if (httpError && httpError.error) {
          this.error = httpError.error.detail;
        }
        this.cd.detectChanges();
      })
    );
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.subscription.unsubscribe();
  }

  subscribeToNewsletter() {
    this.store.dispatch(new SendSubscription());
    this.sent = true;
    this.cd.detectChanges();
  }

  resubscribeToNewsletter() {
    this.store.dispatch(new UpdateSubscription(
      {
        id: this.currentSubscription.user,
        email: this.currentSubscription.email,
        confrimed: this.currentSubscription.confirmed,
        unsubscribed: true
      }
    ));
    this.cd.detectChanges();
  }
}
